import React from 'react'

import endo from '../img/endo.jpg'
import onuro from '../img/oncouro.jpg'
import kidn from '../img/kidicon.jpg'
import female from '../img/female.jpg'


const Services = () => {
    return (
        <>
            <div className='services'>
                <br />
                <h1 className='text-center'>Our Services</h1>
                <p className='text-center'>We offer expert solutions for a variety of urological conditions, from routine concerns to complex cases.</p>

                <div className='services2'>

                    <div className='services3'>
                        <img src={endo} />
                        <h1>Endo Urology Care</h1>
                        <p>Dr. Manish Khattar specializes in Endo Urology Care, providing personalized treatments for urological conditions with expert care.</p>
                    </div>

                    <div className='services3'>
                        <img src={onuro} />
                        <h1>Uro Oncology Care</h1>
                        <p>Dr. Manish Khattar specializes in Uro Oncology Care, offering advanced treatments for urological cancers and expert support</p>
                    </div>

                    <div className='services3'>
                        <img src={kidn} />
                        <h1>Kidney Transplant</h1>
                        <p>Dr. Manish Khattar specializes in Kidney Transplant, providing expert care and innovative solutions for your renal health.</p>
                    </div>

                    <div className='services3'>
                        <img src={female} />
                        <h1>Female Urology Care</h1>
                        <p>Dr. Manish Khattar specializes in Female Urology Care, offering personalized treatments for women's urological health concerns.</p>
                    </div>

                </div>



                <div className='services2'>

                    <div className='services3'>
                        <img src={endo} />
                        <h1>Pediatric Urology Care</h1>
                        <p>Dr. Manish Khattar specializes in Pediatric Urology Care, offering expert treatments for children's urological health needs.</p>
                    </div>

                    <div className='services3'>
                        <img src={onuro} />
                        <h1>Reconstructive Urology Care</h1>
                        <p>Dr. Manish Khattar specializes in Reconstructive Urology Care, offering advanced surgical solutions for urological challenges.</p>
                    </div>

                    <div className='services3'>
                        <img src={kidn} />
                        <h1>Andrology Urology Care</h1>
                        <p>Dr. Manish Khattar specializes in Andrology Urology Care, offering treatments for male reproductive and urological health.</p>
                    </div>

                    <div className='services3'>
                        <img src={female} />
                        <h1>General Urology Care</h1>
                        <p>Dr. Manish Khattar specializes in General Urology Care, providing comprehensive treatments for various urological health issues.</p>
                    </div>

                </div>








            </div>



        </>
    )
}

export default Services